module.exports = __webpack_public_path__ + "img/puroak.icon.magnifyingGlass.asset.df2383aa.svg";